import React from 'react';

export default function AccountValidationLoading({
  open,
  name = '',
  birthY = '',
  birthM = '',
  birthD = '',
  bizNo = '',
  bankName = '',
  accountNo = '',
}) {
  if (!open) return null;

  const formattedBirth =
    birthY && birthM && birthD ? `${birthY}년 ${birthM}월 ${birthD}일` : '';

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
      }}
      role="dialog"
      aria-modal="true"
    >
      <div
        style={{
          width: 320,
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 12px 36px rgba(0,0,0,0.18)',
          padding: 20,
          textAlign: 'left',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontWeight: 700, color: '#2a62ff', fontSize: 16 }}>
            계좌 실명 조회 중...
          </span>
        </div>

        <div
          style={{
            height: 120,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            marginTop: 12,
            marginBottom: 12,
          }}
        >
          <div
            style={{
              width: 62,
              height: 46,
              border: '2px solid #dfe3eb',
              borderRadius: 6,
              position: 'relative',
              background: 'linear-gradient(180deg, #f9fbff 0%, #f2f5fb 100%)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: -10,
              width: 22,
              height: 22,
              borderRadius: '50%',
              backgroundColor: '#ff5a60',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 14,
              boxShadow: '0 4px 10px rgba(255,90,96,0.45)',
            }}
          >
            ✓
          </div>
          <div
            aria-hidden
            style={{
              position: 'absolute',
              top: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 6,
              alignItems: 'center',
              animation: 'ng-bounce 1.4s infinite ease-in-out',
            }}
          >
            <div
              style={{
                width: 16,
                height: 16,
                borderLeft: '3px solid #c3ccdc',
                borderBottom: '3px solid #c3ccdc',
                transform: 'rotate(-45deg)',
              }}
            />
            <div
              style={{
                width: 16,
                height: 16,
                borderLeft: '3px solid #c3ccdc',
                borderBottom: '3px solid #c3ccdc',
                transform: 'rotate(-45deg)',
              }}
            />
            <div
              style={{
                width: 16,
                height: 16,
                borderLeft: '3px solid #c3ccdc',
                borderBottom: '3px solid #c3ccdc',
                transform: 'rotate(-45deg)',
              }}
            />
          </div>
        </div>

        <div style={{ lineHeight: 1.8, fontSize: 14, color: '#111' }}>
          {bizNo ? (
            <div>
              사업자번호: <strong>{bizNo}</strong>
            </div>
          ) : (
            <>
              <div>
                이름 : <strong>{name || '-'}</strong>
              </div>
              <div>
                생년월일: <strong>{formattedBirth || '-'}</strong>
              </div>
            </>
          )}
          <div>
            은행 : <strong>{bankName || '-'}</strong>
          </div>
          <div>
            계좌번호 : <strong>{accountNo || '-'}</strong>
          </div>
        </div>

        <div
          style={{
            marginTop: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            color: '#4a5568',
            fontSize: 13,
          }}
        >
          <span
            className="ng-spinner"
            style={{
              width: 16,
              height: 16,
              borderRadius: '50%',
              border: '2px solid #c3ccdc',
              borderTopColor: '#2a62ff',
              display: 'inline-block',
              animation: 'ng-spin 0.75s linear infinite',
            }}
          />
          계좌 유효성 검증을 진행 중입니다...
        </div>
      </div>

      <style>
        {`
          @keyframes ng-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes ng-bounce {
            0%, 100% { transform: translateY(0px); opacity: 0.6; }
            50% { transform: translateY(8px); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}
